import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Edit from '@material-ui/icons/Edit';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { grey, blue } from '@material-ui/core/colors';

import EditItemDialog from './EditItemDialog';

const styles = () => ({
  normalEditColor: { color: grey[600] },
  disableEditColor: { color: grey[500] },
  blueEditColor: { color: blue[600] },
});

class EditItemButton extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    contactId: PropTypes.number,
    info: PropTypes.shape({}).isRequired,
    isApproved: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    updateStateData: PropTypes.func.isRequired,
    reloadStore: PropTypes.func.isRequired,
    modeTable: PropTypes.bool,
    isAllowedToUpdate: PropTypes.bool,
    isRetailPage: PropTypes.bool,
  };

  static contextTypes = {
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    contactId: null,
    modeTable: false,
    isAllowedToUpdate: true,
    isRetailPage: false,
  };

  state = {
    info: this.props.info,
    open: false,
  };

  componentWillReceiveProps({ info }) {
    this.setState({ info });
  }

  onSelect = (item) => {
    const { info } = this.props;
    this.setState({ info: { ...info, productData: { ...item } } });
  }

  handleClose = () => this.setState({ open: false });

  handleOpen = () => this.setState({ open: true });

  render() {
    const { info, open } = this.state;
    const { readOnly } = this.context;
    const {
      classes,
      contactId,
      isApproved,
      updateStateData,
      reloadStore,
      title,
      modeTable,
      isAllowedToUpdate,
      isRetailPage,
    } = this.props;
    return (
      <div title={title}>
        <IconButton
          disabled={isAllowedToUpdate ? readOnly : true}
          onClick={this.handleOpen}
          style={{ padding: 5 }}
        >
          <Edit className={classes.blueEditColor} />
        </IconButton>
        <EditItemDialog
          contactId={contactId}
          info={info}
          isEdit
          onRequestClose={this.handleClose}
          onSelect={this.onSelect}
          open={open}
          key={open}
          updateStateData={updateStateData}
          reloadStore={reloadStore}
          isRetailPage={isRetailPage}
        />
      </div>
    );
  }
}

export default withStyles(styles)(EditItemButton);
